import { REHYDRATE } from "redux-persist";
import {
    ANY_FIELD_UPDATE,
    updatedObject,
    SUBFIELD_UPDATE,
    FORMFIELD_UPDATE,
} from "../actions/formActions";
import {
    REPORT_UPLOAD_EDIT,
    REPORT_UPLOAD_INIT,
    CONFIRM_ACCOUNT_BEGIN,
    CONFIRM_ACCOUNT_SUCCESS,
    CONFIRM_ACCOUNT_FAIL,
    REPORT_CREATE_RECORD_BEGIN,
    REPORT_CREATE_RECORD_SUCCESS,
    REPORT_CREATE_RECORD_FAIL,
    CREATE_EMAIL_RECORD_BEGIN,
    CREATE_EMAIL_RECORD_SUCCESS,
    CREATE_EMAIL_RECORD_FAIL,
} from "../actions/reportUploadAction";
import { LOGOUT } from "../actions/loginStateActions";

// temp initial states, will change to empty state when ready
const INITIAL_STATE = {
    data: {},
    status: "uninitialized",
};

export default function reportUploadWorkspaceReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case REHYDRATE:
            return state;

        case ANY_FIELD_UPDATE: {
            if (action.storeName !== "reportUploadWorkspace") return state;

            return {
                ...state,
                data: updatedObject(state.data, action.accessPath, action.newVal),
            };
        }

        case FORMFIELD_UPDATE: {
            if (action.storeName !== "reportUploadWorkspace") return state;

            return Object.assign({}, state, {
                data: { ...state.data, [action.fieldName]: action.newVal },
            });
        }

        case REPORT_UPLOAD_INIT: {
            return { data: INITIAL_STATE.data, status: "editing" };
        }

        case REPORT_UPLOAD_EDIT: {
            return { data: state.data, status: "editing" };
        }

        case CONFIRM_ACCOUNT_BEGIN: {
            return Object.assign(state, { status: "submitting" });
        }

        case CONFIRM_ACCOUNT_SUCCESS: {
            return Object.assign({}, state, {
                data: {
                    type: state.data.reportType,
                    user: action.result.user,
                    company: action.result.company,
                },
                status: "completed",
            });
        }

        case CONFIRM_ACCOUNT_FAIL: {
            return { status: "fail", reason: action.reason, data: state.data };
        }

        case REPORT_CREATE_RECORD_BEGIN: {
            return Object.assign(state, { status: "submitting" });
        }

        case REPORT_CREATE_RECORD_SUCCESS: {
            return { data: action.result, status: "updated" };
        }

        case REPORT_CREATE_RECORD_FAIL: {
            return { status: "fail", reason: action.reason, data: state.data };
        }

        case CREATE_EMAIL_RECORD_BEGIN: {
            return Object.assign(state, { status: "submitting" });
        }

        case CREATE_EMAIL_RECORD_SUCCESS: {
            return { data: action.result, status: "updated" };
        }

        case CREATE_EMAIL_RECORD_FAIL: {
            return { status: "fail", reason: action.reason };
        }

        case SUBFIELD_UPDATE: {
            if (action.storeName !== "reportUploadWorkspace") return state;

            const { [action.fieldName]: oldArray, ...others } = state.data;
            let newArray;
            if (action.idx || action.idx === 0) {
                newArray = oldArray.map((rec, idx) => {
                    if (idx !== action.idx) return rec;
                    if (action.subFieldName)
                        return { ...rec, [action.subFieldName]: action.newVal };
                    return action.newVal;
                });
            } else {
                newArray = {
                    ...oldArray,
                    [action.subFieldName]: action.newVal,
                };
            }

            return Object.assign({}, state, {
                data: { ...others, [action.fieldName]: newArray },
            });
        }

        case LOGOUT:
            return INITIAL_STATE;

        default:
            return state;
    }
}
